import React, { useState, useEffect } from "react";
import MasterTable from "../common/MasterTable";
import RoleModal from "../role/RoleModal";
import RoleFilterModal from "../role/RoleFilterModal";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";

const defaultFilterData = {
  userProfile: null,
  roleName: "",
  status: [],
  fromDate: "",
  toDate: "",
};

const RoleMaster = () => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [roleData, setRoleData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [pageDetails, setPageDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);

  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  const handleReset = () => {
    setFilterData(defaultFilterData);
    // fetchRoleData(1, defaultFilterData);
  };

  useEffect(() => {
    fetchRoleData(1, filterData);
  }, []);

  const fetchRoleData = (currentPage, filters = filterData) => {
    const payload = {
      username: loggedInUserName,
      userProfile: filters.userProfile?.value || "",
      roleName: filters.roleName || "",
      status: filters.status.length > 0 ? filters.status : ["Active", "Block", "In-Active"],
      fromDate: formatDate(filters.fromDate),
      toDate: formatDate(filters.toDate),
    };

    setLoading(true);

    axiosPostApi(
      `${apiList.FETCH_ROLE_DATA}?&pageSize=${pageSize}&pageNo=${currentPage}`,
      payload
    )
      .then((response) => {
        if (
          response?.data?.status === true &&
          response?.data?.respCode === "00"
        ) {
          setPageDetails(response?.data?.pageDetails);
          const modifiedData = modifyStructure(response?.data?.data);
          setRoleData(modifiedData);

          if (modifiedData?.length === 0) {
            setNoData(true);
          } else {
            setNoData(false);
          }
        } else {
          setNoData(true);
          setRoleData([]);
        }
      })
      .catch((error) => {
        CustomAlert({
          title: "Error",
          text: "An error occurred while fetching the data. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const modifyStructure = (response) => {
    return response?.map((item, index) => ({
      ...item,
      id: index + 1,
    }));
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const handleAuthorization = (authData) => {
    const requestBody = {
      ...authData,
      username: loggedInUserName,
      status: "1",
    };

    axiosPostApi(apiList.AUTH_ROLE_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          toast.success("User menu Authorized successfully!");
          fetchRoleData(1, filterData);
        } else {
          CustomAlert({
            title: "Failed to Authorized",
            text:
              response?.data?.message ||
              "Invalid credentials. Please try again!",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        console.error("Error Authorized Role", error);
        toast.error("Failed to Authorized Role.");
      });
  };

  const roleHeaders = [
    "Status",
    "User Profile",
    "Role Code",
    "Role Name",
    "Created on Date-time",
  ];

  const roleHeaderToKeyMap = {
    Status: "authStatus",
    "User Profile": "userProfile",
    "Role Code": "userRole",
    "Role Name": "roleName",
    "Created on Date-time": "createdDt",
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction("");
  };

  const handlerRole = (data, actionType = "view") => {
    setModalAction(actionType);
    if (actionType === "add") {
      setEditData({});
      setShowModal(true);
    } else {
      let venData = roleData.find((item) => item?.id === data?.id);
      if (venData) {
        setEditData(venData);
        setShowModal(true);
      }
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <MasterTable
            headers={roleHeaders}
            data={roleData}
            handleAction={handlerRole}
            filterFields={["userRole"]}
            entityType="Role"
            headerToKeyMap={roleHeaderToKeyMap}
            loading={loading}
            noData={noData}
            handleAuth={handleAuthorization}
            pageDetails={pageDetails}
            currentPage={currentPage}
            pageSize={pageSizeCount}
            totalRecord={totalRecord}
            fetchNextData={fetchRoleData}
            setCurrentPage={setCurrentPage}
            openModalFilter={openModalFilter}
            handleReset={handleReset}
            filterData={filterData}
            fetchData={() => fetchRoleData(1, defaultFilterData)}
          />
          <RoleModal
            show={showModal}
            handleClose={handleCloseModal}
            editData={editData}
            action={modalAction}
            fetchRoleData={() => fetchRoleData(1, filterData)}
          />
          {isModalOpenFilter ? (
            <RoleFilterModal
              show={isModalOpenFilter}
              handleClose={closeModalFilter}
              setRoleData={setRoleData}
              setPageDetails={setPageDetails}
              setNoData={setNoData}
              pageSize={pageSize}
              currentPage={currentPage}
              filterData={filterData}
              setFilterData={setFilterData}
              handleReset={handleReset}
            />
          ) : null}
        </>
      )}
    </div>
  );
};

export default RoleMaster;